import { render, staticRenderFns } from "./PurchasesExchange.vue?vue&type=template&id=175f6bd4"
import script from "./PurchasesExchange.vue?vue&type=script&lang=js"
export * from "./PurchasesExchange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports